import styles from '../part-price.module.scss';
import cx from 'classnames';
import { PartUnitPriceProps } from './types';
import {
  checkIsRiyal,
  getRiyalFormattedPrice,
  shouldAddCurrencyInPrice
} from 'app/[lang]/[esite]/utils/paymentUtils';

const PartUnitPrice = ({
  unitPrice,
  currencyCode,
  showNewMobileStyles,
  isRTL,
  currencyLdFeatureFlag
}: PartUnitPriceProps) => {
  const saudiCurrencySymbol =
    currencyLdFeatureFlag && checkIsRiyal(currencyCode);
  const showCurrencyText = shouldAddCurrencyInPrice(currencyCode);
  const mobileStyle = () => {
    return saudiCurrencySymbol
      ? getRiyalFormattedPrice({
          price: unitPrice as string,
          priceWrapperClasses:
            'text-xl text-univers--bold u-color--ExtraDarkGray px-1',
          isRTL: isRTL,
          size: 'xs'
        })
      : `${unitPrice} ${currencyCode}`;
  };
  const desktopStyle = () => {
    return saudiCurrencySymbol ? (
      getRiyalFormattedPrice({
        price: unitPrice as string,
        priceWrapperClasses:
          'text-xl text-univers--bold u-color--ExtraDarkGray px-1',
        isRTL: isRTL,
        size: 'xs'
      })
    ) : (
      <>
        <span className={styles['price--unit']}>{unitPrice}</span>
        {''} {showCurrencyText ? currencyCode : ''}
      </>
    );
  };
  return (
    <p
      className={cx('cat-u-theme-typography-body cat-u-margin-bottom-none', {
        [styles['price--discounted']]: !showNewMobileStyles,
        [styles['price--unit-mobile']]: showNewMobileStyles
      })}
    >
      {showNewMobileStyles ? mobileStyle() : desktopStyle()}
    </p>
  );
};
export default PartUnitPrice;
